import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";

const Wrapper = styled(Box)`
  background-color: white;
  height: 100%;
  width: 100%;
  overflow: auto;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledMobileFiltersModal = styled(Box)<{ isOpen: boolean }>`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  z-index: 2500;
`;

const FilterContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 0 ${({ theme }) => theme.space[6]}px 0;
  height: inherit;
  justify-content: space-between;

  .MobileFilter_ArrowRight {
    width: 6px;
  }
  a:not(:last-of-type) {
    border-bottom: 1px solid #d8d8d8;
  }
`;

const RightAdornment = styled.div`
  align-items: center;
  display: flex;
`;

const Buttons = styled(Flex)`
  padding: 16px 16px 20px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.tone.white};
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const FilterItemWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  align-items: center;
  overflow: hidden;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 48px;
    right: 0;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      #ffffff
    );
  }
`;

const FilterItemTitle = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.tone.black};
  line-height: 1.5;
  letter-spacing: 0.4px;
  width: 114px;
`;

const FilterItemInfo = styled(FilterItemTitle)`
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  overflow-wrap: break-word;
  white-space: nowrap;
`;

const FilterContentWrapper = styled.ul`
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.marble};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }
`;

const ContentWrapper = styled.div`
  overflow: auto;
  padding: 0 ${({ theme }) => theme.space[3]}px;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const FilterMultiColumn = styled(FilterContentWrapper)<{
  isMultiColumn?: boolean;
  count: number;
}>`
  list-style: none;
  margin: 11px 15px 15px;
  display: grid;
  row-gap: ${({ theme }) => theme.space[2]}px;
  ${({ isMultiColumn, count }) =>
    isMultiColumn &&
    `
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-template-rows: repeat(${count || 1}, auto);
  `}
`;

export {
  Wrapper,
  StyledMobileFiltersModal,
  FilterContent,
  RightAdornment,
  FilterItemWrapper,
  Buttons,
  FilterItemTitle,
  FilterItemInfo,
  FilterContentWrapper,
  FilterMultiColumn,
  ContentWrapper,
};
